//css-------------------
import "@/css/home/product_content.scss";

//swiper
import(/* webpackPrefetch: true */ "swiper/css/pagination");


//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import(/* webpackPrefetch: true */ "@/js/share/components/_tracker");
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";
import { sidenav_toggle } from "@/js/share/components/_sidenav.js";


//npm lib  
import $ from "jquery";
import Swiper from "swiper";
import { Pagination, Navigation, A11y, Thumbs } from "swiper/modules";
import { createApp, baseData, baseWatch, baseMethods } from "@/js/share/_home_app";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";

const app = createApp({
    data() {
        return {
            ...baseData(),
        };
    },
    watch: {
        ...baseWatch(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            _this.gallery_handler();
            $('.content').find('img').each(function () {
                const _width = $(this).attr('width');
                if (!_width !== undefined) {
                    const _style = $(this).attr('style') ? $(this).attr('style') + ';' : '';
                    $(this).attr('style', _style + 'width:' + (_width / 16) + 'rem;');
                }
            });
        });
    },
    methods: {
        ...baseMethods,
        sidenav_toggle,
        gallery_handler() {
            sponsor_swiper();

            const controller_swiper = '.gallery_controller';
            const controller_container = controller_swiper + ' .swiper';

            const controllerSwiper = new Swiper(controller_container, {
                modules: [Pagination, Navigation, A11y, Thumbs],
                grabCursor: true,
                speed: 500,
                slidesPerView: 7,
                slidesPerGroup: 7,
                breakpoints: {
                    320: {
                        slidesPerView: 3,
                    },
                    640: {
                        slidesPerView: 7,
                    }
                },
                a11y: {
                    enabled: true,
                    firstSlideMessage: "第一則",
                    lastSlideMessage: "最後一則",
                    paginationBulletMessage: "到第 {{index}} 則",
                },
            });

            const $swiper = '.gallery_swiper';
            const container = $swiper + ' .swiper';
            const pagination = $swiper + ' .swiper-pagination';
            const button_next = $swiper + ' .swiper-button-next';
            const button_prev = $swiper + ' .swiper-button-prev';

            const mySwiper = new Swiper(container, {
                modules: [Pagination, Navigation, A11y, Thumbs],
                grabCursor: true,
                speed: 500,
                thumbs: {
                    swiper: controllerSwiper
                },
                pagination: {
                    el: pagination,
                    clickable: true,
                    type: 'custom',
                    renderCustom: function (swiper, current, total) {
                        return '<div class="swiper_fraction">共 ' + total + ' 張，目前顯示 ' + current + '/' + total + ' 張</div>';
                    },
                },
                navigation: {
                    nextEl: button_next,
                    prevEl: button_prev,
                },
                a11y: {
                    enabled: true,
                    firstSlideMessage: "第一則",
                    lastSlideMessage: "最後一則",
                    paginationBulletMessage: "到第 {{index}} 則",
                },
            });
        }
    },
}).mount("#app");

